module.exports = __webpack_public_path__ + "static/media/flag-japan.aa32c1be.svg";